import { HOST } from "./env";

export const APP_HORIZONTAL_LOGO = `${HOST}/assets/enable-us-by-mindtickle-h.svg`;
export const APP_LOGO = `${HOST}/assets/enable-us-logo-blue-black.svg`;
export const APP_STACKED_LOGO = `${HOST}/assets/enable-us-by-mindtickle-s.svg`;
export const APP_TRADEMARKED_LOGO = `${HOST}/assets/mindtickle-trademarked-logo.svg`;
export const AUTH_IMAGE = `${HOST}/assets/sign-up-background-@2x.jpeg`;
export const DEFAULT_COVER = `${HOST}/assets/enable-default-thumbnail-320.png`;
export const FROM_NAME_REPLY_TO = `${HOST}/assets/from-name-reply-to@2x.mp4`;
export const GOOGLE_CONSENT = `${HOST}/assets/google-consent.jpeg`;
export const IFRAME_EXPLANATION = `${HOST}/assets/iframe-quick-explanation@2x.mp4`;
export const NO_SEARCH_RESULTS = `${HOST}/assets/no-search-results.png`;
export const PERSON_AVATAR = `${HOST}/assets/person.svg`;
export const PHONE_LOGO = `${HOST}/assets/phone.svg`;
export const PSPDFKIT_ASSETS_URL = `${HOST}/assets/`;
export const PSPDFKIT_VIEWER_STYLESHEET = `${HOST}/assets/PSPDFKitViewer.css`;
export const REVIEW_STEP_NO_CONTENT = `${HOST}/assets/review-step-no-content@2x.png`;
export const SECTION_HEADERS_EXPLANATION = `${HOST}/assets/section-headers@2x.mp4`;
export const TOOLTIP_FAVICON = `${HOST}/assets/favicon-tooltip@2x.png`;
export const TOOLTIP_IMAGE_GALLERY_SELECT_BANNER = `${HOST}/assets/select-banner-image-review-page@2x.png`;
export const TOOLTIP_IMAGE_GALLERY_SELECT_COVER = `${HOST}/assets/select-cover-image@2x.png`;
export const TOOLTIP_IMAGE_GALLERY_SELECT_THUMBNAIL = `${HOST}/assets/edit-room-thumbnail@2x.png`;
export const TOOLTIP_MAP_TEMPLATES = `${HOST}/assets/add-mutual-action-plan.png`;
export const TOOLTIP_PAGE_TITLE = `${HOST}/assets/page-title-tooltip@2x.png`;
export const TOOLTIP_ROOM_ANALYTICS_LINK = `${HOST}/assets/room-analytics-link-tooltip@2x.jpg`;
export const TOOLTIP_ROOM_CONTENT_TILE_RESIZE = `${HOST}/assets/room-content-tile-resize-tooltip.mp4`;
export const TOOLTIP_ROOM_SETTINGS_THUMBNAIL = `${HOST}/assets/room-thumbnail-settings@2x.png`;
export const TOOLTIP_ROOM_VISITOR_LINK = `${HOST}/assets/room-visitor-link-tooltip@2x.jpg`;
export const TOOLTIP_SALES_ACTIONS = `${HOST}/assets/sales-actions-tooltip-image@2x.png`;
export const TOOLTIP_SELECT_PRIVACY_POLICY_NAME = `${HOST}/assets/select-privacy-policy-name.png`;
export const TOOLTIP_SELECT_STORAGE_ACCOUNT = `${HOST}/assets/select-connection-account.png`;
export const TOOLTIP_SIGNABLE_TEMPLATES = `${HOST}/assets/add-signable-document.png`;
export const TOOLTIP_VENDOR_MAP_TEMPLATES = `${HOST}/assets/vendor-add-mutual-action-plan.png`;
export const TOOLTIP_VENDOR_SIGNABLE_TEMPLATES = `${HOST}/assets/vendor-add-signable-document.png`;
